module.exports = __webpack_public_path__ + "images/arrow_top-2a54a0.svg";